import { useState, useEffect } from "react";
import { FeatureFlagsQuery, TenantQuery } from "services/graphql/generated";
import { AppContextInterface } from "types/appContext";

export function useAppProvider(
  featureFlags: FeatureFlagsQuery["featureFlags"],
  tenant: TenantQuery["tenant"]
): { appContextValue: AppContextInterface } {
  const [featureFlagsState, setFeatureFlagsState] = useState<
    FeatureFlagsQuery["featureFlags"]
  >([]);
  const [tenantState, setTenantState] = useState<TenantQuery["tenant"]>(null);

  useEffect(() => {
    setFeatureFlagsState(featureFlags);
  }, [featureFlags]);

  useEffect(() => {
    setTenantState(tenant);
  }, [tenant]);

  const appContextValue: AppContextInterface = {
    featureFlags: featureFlagsState,
    updateFeatureFlags: (flags: FeatureFlagsQuery["featureFlags"]) => {
      setFeatureFlagsState(flags);
    },
    tenant: tenantState,
  };

  return { appContextValue };
}
